import React, { useState, useEffect } from "react";
import "./task.css";
import { useDispatch } from "react-redux";
import { updateProcess } from "../../store/actionCreator";
import { getToken, base_url } from "../../config/config";

import axios from "axios";

export default function Task({ id, title, color, onDelete, isSelected, onSelectionChange }) {
  const dispatch = useDispatch();

  const [hours, setHours] = useState("");
  const [miterbiter, setMiterbiter] = useState("");
  const [employees, setEmployees] = useState([]);

  const handleHoursChange = (event) => {
    const newHours = parseInt(event.target.value);
    setHours(newHours);
  };

  const handleMiterbiterChange = (event) => {
    const selectedMiterbiter = event.target.value;
    setMiterbiter(selectedMiterbiter);
  };
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = getToken(); // Make sure to import getToken from your auth utils
        const response = await axios.get(`${base_url}/v1/getAllEmployees`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data && Array.isArray(response.data)) {
          setEmployees(response.data);
        } else {
          console.error("Unexpected employee data format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);
  useEffect(() => {
    if (hours !== "" && miterbiter !== "") {
      submitTask();
    }
  }, [hours, miterbiter]);

  const submitTask = () => {
    let days;
    if (hours <= 8) {
      days = 1;
    } else {
      days = 2;
    }
    const currentDate = new Date().toISOString().split("T")[0];
    const data = { days, hours, miterbiter, date: currentDate };
    dispatch(updateProcess(title, data));
  };

  const handleSelectionChange = (e) => {
    if (onSelectionChange) {
      onSelectionChange(id, e.target.checked);
    }
  };

  return (
    <div className="task" style={{ backgroundColor: color, position: 'relative' }}>
      {/* Selection Checkbox */}
      {onSelectionChange && (
        <div style={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          zIndex: 10
        }}>
          <input
            type="checkbox"
            checked={isSelected || false}
            onChange={handleSelectionChange}
            style={{
              width: '16px',
              height: '16px',
              cursor: 'pointer',
              accentColor: '#007bff'
            }}
          />
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: '8px'
        }}>
          <h3 style={{ color: "black", margin: 0 }}>{title}</h3>
          <span style={{
            fontSize: '12px',
            color: '#666',
            backgroundColor: 'rgba(255,255,255,0.7)',
            padding: '2px 6px',
            borderRadius: '3px'
          }}>
            ID: {id}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: '8px'
          }}
        >
          <input
            type="number"
            placeholder="Hours"
            value={hours}
            onChange={handleHoursChange}
            className="numberBox"
          />
          <select
            className="selectBox"
            value={miterbiter}
            onChange={handleMiterbiterChange}
          >
            <option value="">Select Employee</option>
            {employees.map((employee) => (
              <option key={employee._id} value={employee.name}>
                {employee.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '8px'
        }}>
          <button
            onClick={() => onDelete(id)}
            style={{
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '4px 8px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Delete
          </button>

          {isSelected && (
            <span style={{
              fontSize: '10px',
              color: '#007bff',
              fontWeight: 'bold',
              backgroundColor: 'rgba(0, 123, 255, 0.1)',
              padding: '2px 6px',
              borderRadius: '3px'
            }}>
              Selected
            </span>
          )}
        </div>
        {/* <button onClick={submitTask}>Submit</button> */}
      </div>
    </div>
  );
}
